import uuid from 'react-uuid';
import { useSelector } from 'react-redux';
import { Grid, MenuItem } from '@material-ui/core';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import QCXFinalTextField from '../../shared-components/final-text-field/QCXFinalTextField';
import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import { selectMoedas } from '../../features/moeda/moedaSlice';
import { selectDespesasReceitas } from '../../features/despesa-receita/despesaReceitaSlice';
import QCXFinalBondManagerOld from '../../shared-components/final-gerenciador-relacionamento/QCXFinalBondManagerOld';
import QCXTextField from '../../shared-components/text-field/QCXTextField';
import QCXSelectMoedaAutocomplete from '../../shared-components/final-select-moeda-field/QCXSelectMoedaAutocomplete';
import QCXSelectDespesaReceitaAutocomplete from '../../shared-components/select-despesa-receita/QCXSelectDespesaReceitaAutocomplete';
import QCXFinalAlternativeCurrencyField from '../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import { unnormalizeNumeral } from '../../utils/general/general-utils';
import { houseCustosSelectors, houseCustosSliceActions } from '../../features/house-custo/houseCustoSlices';
import QCXFinalSelectGenericoAutocomplete from '../../shared-components/select-tipo-frete/QCXFinalSelectGenericoAutocomplete';

export default function QCXHouseCustosForm({
    initialValues,
    handleSubmit,
    isConsult,
    isUpdate,
    controlComponentProps,
    authInfo = {},
    Roles = [],
    requiredRoles = [],
    dataGridDivProps = {},
    isLoading,
}) {

    const { t } = useTranslation();

    const despesas = useSelector(selectDespesasReceitas);

    const moedas = useSelector(selectMoedas);

    const [tipoPagamento, setTipoPagamento] = useState(null);

    const handleTipoPagamentoChange = (event) => {
        setTipoPagamento(event.target.value);
    };

    const [declarado, setDeclarado] = useState(null);

    const handleDeclaradoChange = (event) => {
        setDeclarado(event.target.value);
    };

    const [profit, setProft] = useState(null);

    const handleProfitChange = (event) => {
        setProft(event.target.value);
    };

    const [calculo, setCalculo] = useState(null);

    const isCalculoHasValueIsEmbarque = () => calculo === "EMBARQUE";

    const handleCalculoChange = (event) => {
        setCalculo(event.target.value);
    };

    const handleAdd = useCallback(async (currentVinculo, currentVinculos, handleSuccessAddVinculo) => {

        const selectMoeda = moedas.find(x => x?.id === currentVinculo?.moeda?.id);

        const selectDespesa = despesas.find(x => x?.id === currentVinculo?.despesaReceita?.id);

        const custo = {
            id: uuid(),
            despesaReceita: selectDespesa,
            moeda: selectMoeda,
            tipoPagamento,
            valorCompraMoeda: currentVinculo?.valorComprar,
            valorCompraReais: currentVinculo?.valorComprar,
            valorCompraDolar: currentVinculo?.valorComprar,
            valorVendaMoeda: currentVinculo?.valorVenda,
            valorVendaReais: currentVinculo?.valorVenda,
            valorVendaDolar: currentVinculo?.valorVenda,
            declarado,
            profit,
            percentualOrigem: 0,
            percentualDestino: 0,
            valorProfitOrigemMoeda: 0,
            valorProfitOrigemReais: 0,
            valorProfitOrigemDolar: 0,
            valorProfitDestinoMoeda: 0,
            valorProfitDestinoReais: 0,
            valorProfitDestinoDolar: 0,
        }


        const updatedVinculos = [...currentVinculos, custo];

        handleSuccessAddVinculo(updatedVinculos);

        setDeclarado(null);

        setProft(null);

        setTipoPagamento(null);

        setCalculo(null);

    }, [declarado, profit]);

    const handleUpdate = useCallback(async () => {

    });

    const handleReferencia = () => false;

    const config = useMemo(
        () => ({
            selectors: {
                selectStatus: houseCustosSelectors.selectStatus,
                selectMode: houseCustosSelectors.selectMode,
                selectModel: houseCustosSelectors.selectModel,
            },
            actions: {
                loading: houseCustosSliceActions.loading,
                resetStatus: houseCustosSliceActions.resetStatus,
                changeToUpdateMode: houseCustosSliceActions.changeToUpdateMode,
                changeToCreateMode: houseCustosSliceActions.changeToCreateMode,
                resetMode: houseCustosSliceActions.resetMode,
                setModel: houseCustosSliceActions.setModel,
                resetModel: houseCustosSliceActions.resetModel,
            },
        }), []);

    const listProps = useMemo(
        () => ({
            name: 'custos',
            columns: [
                {
                    field: 'despesaReceita',
                    headerName: "Despesa / Receita",
                    headerAlign: 'left',
                    align: 'left',
                    flex: 140,
                    valueGetter: ({ row }) => row?.despesaReceita?.description || '-',
                },
                {
                    field: 'moeda',
                    headerName: "Moeda",
                    headerAlign: 'left',
                    align: 'left',
                    flex: 140,
                    valueGetter: ({ row }) => row?.moeda?.description || '-',
                },
                {
                    field: 'tipoPagamento',
                    headerName: "P/C",
                    headerAlign: 'left',
                    align: 'left',
                    flex: 140,
                    valueGetter: ({ row }) => row?.tipoPagamento || '-',
                },
                {
                    field: 'valorCompraMoeda',
                    headerName: "Valor comprar",
                    headerAlign: 'left',
                    align: 'left',
                    flex: 140,
                    valueGetter: ({ row }) => unnormalizeNumeral(row?.valorCompraMoeda) || '-',
                },
                {
                    field: 'valorCompraReais',
                    headerName: "Valor Venda",
                    headerAlign: 'left',
                    align: 'left',
                    flex: 140,
                    valueGetter: ({ row }) => unnormalizeNumeral(row?.valorCompraReais) || '-',
                },
                {
                    field: 'declarado',
                    headerName: "Declarado",
                    headerAlign: 'left',
                    align: 'left',
                    flex: 140,
                    valueGetter: ({ row }) => row?.declarado || '-',
                },
                {
                    field: 'declarado',
                    headerName: "Profit",
                    headerAlign: 'left',
                    align: 'left',
                    flex: 140,
                    valueGetter: ({ row }) => row?.declarado || '-',
                },
            ],
        }), []);

    const formProps = useMemo(
        () => ({
            rootName: 'ignorableFields.volumes',
            fields: [
                {
                    name: 'despesaReceita.id',
                    label: "Despesa / Receita",
                },
                {
                    name: 'moeda.id',
                    label: "Moeda",
                },
                {
                    name: 'valorComprar',
                    label: "Valor Comprar",
                },
            ],
        }),
        []
    );

    return (
        <QCXFormStepWizard
            initialValues={initialValues}
            onSubmit={handleSubmit}
            controlComponentProps={controlComponentProps}
            onChangeListeners={undefined}
            authInfo={authInfo}
            Roles={Roles}
        >
            {({ values }) => (
                <>
                    <Grid container spacing={2} style={{ 'marginTop': '20px' }} xs={12} sm={12} md={12} lg={12} >
                        <Grid item xs={12} sm={3} md={3} lg={3} >
                            <QCXFinalTextField
                                id="numero-processo-mercadoria-code"
                                key="numero-processo-mercadoria-code"
                                name="numeroProcesso"
                                label={t('com.muralis.qcx.agenciamento.numero_processo')}
                                disabled

                            />
                        </Grid>
                    </Grid>
                    <QCXFinalBondManagerOld
                        isParentConsult={isConsult}
                        reducerConfig={config}
                        listProps={listProps}
                        formProps={formProps}
                        controlButtonsGridProps={{
                            add: {
                                xs: 12,
                                sm: 4,
                                md: 4,
                            },
                            update: {
                                xs: 6,
                                sm: 2,
                                md: 2,
                            },
                            clear: {
                                xs: 6,
                                sm: 2,
                                md: 2,
                            },
                        }}
                        handleAdd={handleAdd}
                        handleUpdate={handleUpdate}
                        handleAlreadyExists={handleReferencia}
                    >
                        <>
                            <Grid container spacing={2} style={{ 'marginTop': '20px' }} xs={12} sm={12} md={12} lg={12}>
                                <Grid item xs={12} sm={3} md={3} lg={3}>
                                    <QCXSelectDespesaReceitaAutocomplete
                                        id="despesa-receita-field"
                                        key="despesa-receita-field"
                                        name="ignorableFields.volumes.despesaReceita.id"
                                        label="Despesa / Receita"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3} lg={3}>
                                    <QCXSelectMoedaAutocomplete
                                        id="moeda-field"
                                        key="moeda-field"
                                        name="ignorableFields.volumes.moeda.id"
                                        label="Moeda"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3} lg={3}>
                                    <QCXFinalSelectGenericoAutocomplete
                                        id="select-tipo-pagamento"
                                        key="select-tipo-pagamento"
                                        name="ignorableFields.volumes.tipoPagamento"
                                        label="Tipo de Pagamento"
                                        optionsProp={[
                                            { label: 'PREPAID', value: 'PREPAID' },
                                            { label: 'COLLECT', value: 'COLLECT' },
                                        ]}
                                        initialValues={values}
                                        disabled={isConsult}
                                        
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} style={{ 'marginTop': '20px' }} xs={12} sm={12} md={12}>
                                <Grid item xs={12} sm={3} md={3}>
                                    <QCXFinalAlternativeCurrencyField
                                        id="valor-comprar-field"
                                        name="ignorableFields.volumes.valorComprar"
                                        label="Valor Comprar"
                                        key="valor-valor-comprar-field"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <QCXFinalAlternativeCurrencyField
                                        id="valor-venda-field"
                                        key="valor-venda-field"
                                        name="ignorableFields.volumes.valorVenda"
                                        label="Valor Venda"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <QCXFinalSelectGenericoAutocomplete
                                        id="select-declarado"
                                        key="select-declarado"
                                        name="ignorableFields.volumes.declarado"
                                        label="Declarado"
                                        optionsProp={[
                                            { label: 'Sim', value: 'SIM' },
                                            { label: 'Não', value: 'NAO' },
                                        ]}
                                        initialValues={values}
                                        disabled={isConsult}
                                        
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} style={{ 'marginTop': '20px' }} xs={12} sm={12} md={12}>
                                <Grid item xs={12} sm={2} md={2}>
                                    <QCXFinalSelectGenericoAutocomplete
                                        id="select-profit"
                                        key="select-profit"
                                        name="ignorableFields.volumes.profit"
                                        label="Profit"
                                        optionsProp={[
                                            { label: 'Sim', value: 'SIM' },
                                            { label: 'Não', value: 'NAO' },
                                        ]}
                                        initialValues={values}
                                        disabled={isConsult}
                                        
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <QCXFinalSelectGenericoAutocomplete
                                        id="select-calculo"
                                        key="select-calculo"
                                        name="ignorableFields.volumes.calculo"
                                        label="Cálculo"
                                        optionsProp={[
                                            { label: '% POR EMBARQUE', value: 'EMBARQUE' },
                                            { label: 'VALOR FIXO', value: 'VALOR_FIXO' },
                                        ]}
                                        initialValues={values}
                                        disabled={isConsult}
                                        
                                    />
                                </Grid>
                                {isCalculoHasValueIsEmbarque() ? (
                                    <>
                                        <Grid item xs={12} sm={3} md={3} lg={3}>
                                            <QCXFinalAlternativeCurrencyField
                                                id="origem-percentual-field"
                                                key="origem-percentual-field"
                                                name="ignorableFields.volumes.origemPercentual"
                                                label="% Origem"
                                                disabled={!isCalculoHasValueIsEmbarque()}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3} md={3} lg={3}>
                                            <QCXFinalAlternativeCurrencyField
                                                id="destino-percentual-field"
                                                key="destino-percentual-field"
                                                name="ignorableFields.volumes.destinoPercentual"
                                                label="% Destino"
                                                disabled={!isCalculoHasValueIsEmbarque()}
                                            />
                                        </Grid>
                                    </>
                                ) : (
                                    <Grid item xs={12} sm={3} md={3} lg={3}>
                                        <QCXFinalAlternativeCurrencyField
                                            id="destino-percentual-field"
                                            key="destino-percentual-field"
                                            name="ignorableFields.volumes.destinoPercentual"
                                            label="Valor Destino"
                                            disabled={!isCalculoHasValueIsEmbarque()}
                                        />
                                    </Grid>
                                )}

                            </Grid>
                        </>
                    </QCXFinalBondManagerOld>
                </>
            )}
        </QCXFormStepWizard>
    );
}